module.exports = __webpack_public_path__ + "static/planet1.9b99992b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/planets/planet1.svg
// module id = 695
// module chunks = 213534597649335